import { http } from '@/lib/api/http';
import type { ApiSuccess, ApiList } from '@/shared/types/contracts';

export type LeaderboardEntry = {
  rank: number;
  participant_id: string;
  display_name: string | null;
  avatar_url: string | null;
  total_score: number;
  correct_count: number;
  total_response_time_ms: number;
};

export type MyHistoryEntry = {
  round_id: string;
  round_name: string;
  ended_at: string | null;
  final_rank: number | null;
  total_score: number;
  correct_count: number;
  total_questions: number;
  role_in_round: string;
};

export type MyAnswerDetail = {
  order_index: number;
  question_text: string;
  raw_answer: string | null;
  canonical_answer: string;
  result: 'correct' | 'wrong' | 'timeout';
  score_awarded: number;
  response_time_ms: number | null;
};

export type MyRoundDetail = {
  round_id: string;
  round_name: string;
  ended_at: string | null;
  final_rank: number | null;
  total_score: number;
  correct_count: number;
  total_questions: number;
  avg_response_time_ms: number | null;
  answers: MyAnswerDetail[];
};

/** GET /api/leaderboard/rounds/:roundId */
export async function getRoundLeaderboard(roundId: string): Promise<LeaderboardEntry[]> {
  const res = await http.get<ApiSuccess<LeaderboardEntry[]>>(`/leaderboard/rounds/${roundId}`);
  return res.data.data;
}

/** GET /api/me/history */
export async function getMyHistory(): Promise<MyHistoryEntry[]> {
  const res = await http.get<ApiList<MyHistoryEntry>>('/me/history');
  return res.data.data;
}

/** GET /api/me/rounds/:roundId */
export async function getMyRoundDetail(roundId: string): Promise<MyRoundDetail> {
  const res = await http.get<ApiSuccess<MyRoundDetail>>(`/me/rounds/${roundId}`);
  return res.data.data;
}
